import { render, staticRenderFns } from "./LoginRequiredPanel.vue?vue&type=template&id=e23491dc&scoped=true&"
import script from "./LoginRequiredPanel.vue?vue&type=script&lang=ts&"
export * from "./LoginRequiredPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LoginRequiredPanel.vue?vue&type=style&index=0&id=e23491dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23491dc",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
